import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportVending extends Schema {
    @type("number")
    @defaultValue(0)
    index: number;
    @type("number")
    @defaultValue(1)
    level: number;
    @type("number")
    @defaultValue(0)
    speedLevel: number;
    @type("number")
    @defaultValue(0)
    pending: number;
    @type("number")
    @defaultValue(0)
    sold: number;
    @type("number")
    @defaultValue(0)
    upgradeUntil: number;
}
